/**
 * Calcula o MOD11 para o número informado
 * @param clearValue Número base para o cálculo
 * @param limit Limite da casa de multiplicação
 * Para CPF assume o valor de 12, para CNPJ o valor de 9.
 * @returns Retorna o DV calculado
 */
const mod11 = (clearValue: string, limit: number): number => {
  const value = clearValue.replace(/\D/g, '');
  let sum = 0;
  let mult = 2;

  for (let i = value.length - 1; i >= 0; i--) {
    sum += mult * +value[i];
    if (++mult > limit) {
      mult = 2;
    }
  }
  const dv = ((sum * 10) % 11) % 10;
  return dv;
};

/**
 * Função que valida se a string contém apenas números repetidos.
 * @param ref String númerica
 * @returns True se for contida por apenas caracteres repetidos,
 * false caso contrário
 */
const isRepeated = (ref: string) => {
  const ret = ref.replace(new RegExp(ref[0], 'g'), '').trim().length === 0;
  return ret;
};

/**
 * Valida o CPF. A entrada pode ser com ou sem máscaras.
 * O tamanho deve ser respeitado como em '000.000.000-00' ou '00000000000'.
 * @param value
 */
export const validateCPF = (value: string): boolean => {
  const clearValue = value.replace(/\D/g, '');
  if (clearValue.length !== 11 || !clearValue || isRepeated(clearValue)) {
    return false;
  }

  const valWithoutDvs = clearValue.substring(0, clearValue.length - 2);
  const dv1 = mod11(valWithoutDvs, 12);
  const dv2 = mod11(valWithoutDvs + dv1, 12);
  return valWithoutDvs + dv1 + dv2 === clearValue;
};
